export function getReduxFormError(meta: {
    error: string | null | undefined;
    submitFailed: boolean;
}): string | null | undefined {
    return meta.error && meta.submitFailed ? meta.error : null;
}
